import React, { useEffect } from "react";
import "./policyReferral.css";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Table } from "antd";
import { useState } from "react";
import AxiosInstance from "../../../AxiosInstance";
import { alertError, alertSuccess } from "../../Helper/Alerts";
import OtherPageHeader from "../../../components/OtherHeader";
import moment from "moment";
import { Tab, Tabs } from "react-bootstrap";
import RoleSwitch from "../../Helper/RoleSwitch";
import { insurerListController } from "../../Helper/provider";
export default function PolicyReferral() {
  const POLICY_HOLDER_REFERRAL = "policies";
  const INVESTOR_REFERRAL = "investments";
  const isBigScreen = useMediaQuery({ query: "(min-width: 1224px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const navigate = useNavigate();
  const [key, setKey] = useState(POLICY_HOLDER_REFERRAL);
  var [loading, setLoading] = useState(true);
  var [policies, setPolicies] = useState([]);
  var [userRoles, setUserRoles] = useState([]);
  var [userStatus, setUserStatus] = useState("");
  var [insurer, setInsurer] = useState([]);
  var [updatePayload, setUpdatePayload] = useState({});
  const [showReject, setShowReject] = useState(false);
  const [rejectionReason, setRejectionReason] = useState(false);
  const handleClose = () => setShowReject(false);
  const handleShow = () => setShowReject(true);
  const [investmentData, setInvestmentData] = useState([]);
  const [assignmentData, setAssignmentData] = useState([]);
  const [referralCode, setRefferalCode] = useState("");
  const [skip, setSkip] = useState(0);
  const [phPaginationMetaData, setPHPaginationMetaData] = useState({});
  const [investorPaginationMetaData, setInvestorPaginationMetaData] = useState(
    {}
  );
  var [userName, setUserName] = useState("UserName");
  const getUserMe = async () => {
    const result = await insurerListController();
    setInsurer(result);
    setInsurer(result);
    const url = "/user/me";
    AxiosInstance()
      .get(url)
      .then((resp) => {
        if (resp.status === 200) {
          setUserStatus(resp.data.status);
          setUserRoles(resp.data.userRoles);
          setRefferalCode(resp.data.referralCode);
          const temp = resp.data.userRoles;
          const result = temp.filter(function (letter) {
            return letter !== resp.data.currentRole;
          });
          localStorage.setItem("roles", result);
          localStorage.setItem(
            "username",
            resp.data.firstName + " " + resp.data.lastName
          );
        }
      });
  };
  const getData = async (key, skip) => {
    const result = await getPolicyData(key, skip);
    console.log(result);
    if (key === POLICY_HOLDER_REFERRAL) {
      setPHPaginationMetaData(result.paginationMetaData);

      setAssignmentData(result.data ?? []);
    }
    if (key === INVESTOR_REFERRAL) {
      setInvestorPaginationMetaData(result.paginationMetaData);
      setInvestmentData(result.data ?? []);
    }
    setLoading(false);
  };

  const changeRole = async (role) => {
    const payload = {
      userRole: role,
    };
    AxiosInstance()
      .post("/auth/addNewRole", payload)
      .then((resp) => {
        if (resp.status === 201) {
          // alertSuccess("Role Added Successfully");
          if (role === "INVESTOR") {
            navigate("/investPref");
          } else if (role === "POLICY_MASTER") {
            navigate("/add-policy");
          } else if (role === "PARTNER") {
            navigate("/partner-registration");
          }
        }
      })
      .catch((err) => {
        alertError(err.response.data.message);
      });
  };

  const columns = [
    {
      title: "PH Name",
      dataIndex: "name",
      key: "name",
      render: (text, policy) => (
        <>
          {policy["policy"]["user"]["firstName"] +
            " " +
            policy["policy"]["user"]["lastName"]}
        </>
      ),
    },
    {
      title: "Insurance Co.",
      dataIndex: "insurerName",
      key: "insurerName",
      render: (text, policy) => <>{policy["policy"]["insurer"]["name"]}</>,
    },
    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      key: "policyNumber",
      render: (text, policy) => <>{policy["policy"]["policyNumber"]}</>,
    },
    {
      title: "Assignment Value",
      dataIndex: "assignmentOfferAmount",
      key: "assignmentOfferAmount",
      render: (text, policy) => (
        <>{policy["policy"]["assignmentOfferAmount"]}</>
      ),
    },
    {
      title: "Assignment Request Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, policy) => <>{moment(text).format("DD/MM/YYYY")}</>,
    },
    {
      title: "Policy Assignment Status",
      dataIndex: "status",
      key: "status",
    },
  ];
  const columnsInvestor = [
    {
      title: "Investor Name",
      dataIndex: "name",
      key: "name",
      render: (text, policy) => (
        <>
          {policy["investor"]["firstName"] +
            " " +
            policy["investor"]["lastName"]}
        </>
      ),
    },
    {
      title: "Insurance Co.",
      dataIndex: "insurerName",
      key: "insurerName",
      render: (text, policy) => <>{policy["policy"]["insurer"]["name"]}</>,
    },
    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      key: "policyNumber",
      render: (text, policy) => <>{policy["policy"]["policyNumber"]}</>,
    },
    {
      title: "Assignment Value",
      dataIndex: "assignmentOfferAmount",
      key: "assignmentOfferAmount",
      render: (text, policy) => (
        <>{policy["policy"]["assignmentOfferAmount"]}</>
      ),
    },
    {
      title: "Assignment Request Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, policy) => <>{moment(text).format("DD/MM/YYYY")}</>,
    },

    {
      title: "Policy Investment Status",
      dataIndex: "status",
      key: "status",
    },
  ];

  useEffect(() => {
    let ignore = false;

    if (!ignore) {
      getData(key, 0);
      getUserMe();
    }
    return () => {
      ignore = true;
    };
  }, []);
  const getPolicyData = async (type, skip) => {
    const url = `partner/referral/${type}?take=10&skip=${skip}`;
    const { data } = await AxiosInstance().get(url);
    return data;
  };
  const change = (data) => {
    setSkip((data - 1) * 10);
    getData(key, (data - 1) * 10);
  };

  return (
    <section className="tre_bg-gray">
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="bg-transparent"
      />
      <div className="container bg-referral ">
        <div className="d-flex justify-content-between">
          <div className="col-6 d-flex align-items-end">
            <button
              className="go-portfolio"
              onClick={() => {
                navigate("/partnerDashboard");
              }}
            >
              {" "}
              <i class="fa-solid fa-chevron-left tre_flex-hcenter text-white back-icon "></i>{" "}
              Policy Center
            </button>
          </div>

          <div className="justify-content-center">
            <p className="m-0">Your Referral Code </p>
            <button
              className="d-flex align-items-center pl-3  btn btn-primary  "
              onClick={() => {
                navigator.clipboard.writeText(referralCode);
                alertSuccess("Referal Code Copied");
              }}
            >
              {referralCode}

              <i class="fa-solid fa-files-o tre_flex-hcenter text-black px-2 "></i>
            </button>
          </div>
        </div>
        <Tabs
          className="mt-5"
          activeKey={key}
          onSelect={(k) => {
            setKey(k);
            getData(k, 0);
          }}
        >
          <Tab eventKey={POLICY_HOLDER_REFERRAL} title="Policy Holder Referral">
            <div className="policies-table policy-referral-table">
              <Table
                bordered={true}
                loading={loading}
                scroll={{ x: 400 }}
                className="table"
                dataSource={[...assignmentData]}
                columns={columns}
                pagination={{
                  pageSize: 10,
                  total: phPaginationMetaData?.count,
                  onChange: change,
                }}
              />
            </div>
          </Tab>
          <Tab eventKey={INVESTOR_REFERRAL} title="Investor Referral">
            <div className="policies-table policy-referral-table">
              <Table
                bordered={true}
                loading={loading}
                scroll={{ x: 400 }}
                className="table"
                dataSource={[...investmentData]}
                columns={columnsInvestor}
                pagination={{
                  pageSize: 10,
                  total: investorPaginationMetaData?.count,
                  onChange: change,
                }}
              />
            </div>
          </Tab>
        </Tabs>

        <RoleSwitch userRoles={userRoles} />
      </div>
    </section>
  );
}
